var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInProgress = function SvgInProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.1,
    cy: 38.1,
    r: 35.1,
    fill: "#2bd675"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.033 20.508a3.908 3.908 0 1 1-5.527 5.527 17.181 17.181 0 1 0 0 24.299 3.908 3.908 0 1 1 5.527 5.527 25 25 0 1 1 0-35.353Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m54.074 28.92-10.861-.27a1.079 1.079 0 0 1-.581-.188 1.113 1.113 0 0 1-.395-.476 1.052 1.052 0 0 1-.073-.601c.035-.2.13-.383.271-.524l10.591-10.59a.977.977 0 0 1 .524-.27c.2-.035.41-.009.6.074.192.084.357.22.475.394.118.173.184.375.19.58l.27 10.86c.005.136-.018.27-.067.396a.964.964 0 0 1-.944.615Z",
    fill: "#fff"
  })));
};
export default SvgInProgress;